export default __webpack_public_path__ + "static/media/Email.5336f83c.svg";